import { USER_PROFILE_GROUPS_ADD_REQUEST, USER_PROFILE_GROUPS_ADD_SUCCESS, USER_PROFILE_GROUPS_ADD_FAILURE } from '../../constants/user_profile_groups.constants';

export const userProfileGroupsAddRequest = (user_id, add_groups) => ({
    type: USER_PROFILE_GROUPS_ADD_REQUEST, user_id, add_groups,
});

export const userProfileGroupsAddSuccess = payload => ({
    type: USER_PROFILE_GROUPS_ADD_SUCCESS, payload,
});

export const userProfileGroupsAddFailure = error => ({
    type: USER_PROFILE_GROUPS_ADD_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_profile_groups_actions/user_profile_groups_add.actions.js